export default __webpack_public_path__ + "static/media/customize-png.ac5cc1ed.png";